import { FormattedMessage } from 'react-intl'
import NoConnectionsOrCdw from 'features/connections/ui/NoConnectionsOrCdw'
import HomeMaps from '../HomeMaps/HomeMaps'
import HomeDynamicMaps from '../HomeMaps/HomeDynamicMaps'
import HomeWorkflows from '../HomeWorkflows/HomeWorkflows'
import HomeDynamicWorkflows from '../HomeWorkflows/HomeDynamicWorkflows'

export function HomeGettingStartedNoCDW({
  hasConnections,
  hasMaps,
  latestMaps = [],
  hasWorkflows,
  latestWorkflows = []
}) {
  return (
    <>
      {!hasConnections ? (
        <NoConnectionsOrCdw />
      ) : (
        <>
          <HomeMaps
            title={hasMaps ? null : <FormattedMessage id="home.onboarding.maps.title" />}
            mapsLength={latestMaps?.length}
          >
            {hasMaps ? <HomeDynamicMaps maps={latestMaps} /> : null}
          </HomeMaps>
          <HomeWorkflows
            workflowsLength={latestWorkflows?.length ?? 0}
            title={
              <FormattedMessage
                id={hasWorkflows ? 'home.actions.lastWorkflows.title' : 'home.onboarding.workflows.title'}
              />
            }
          >
            {hasWorkflows ? <HomeDynamicWorkflows workflows={latestWorkflows} /> : null}
          </HomeWorkflows>
        </>
      )}
    </>
  )
}

export default HomeGettingStartedNoCDW
